import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faClose,
	faChevronDown,
	faLink,
} from '@fortawesome/free-solid-svg-icons'

import PopoverButton from '../PopoverButton/index.vue'
import { currencyFormat } from '@/helpers/currency-format'

library.add(faTrashAlt, faClose, faChevronDown, faLink)

@Component({
	components: {
		PopoverButton,
	},
})
export default class CPisIcms extends Vue {
	@Prop({ default: '#aaa', type: String }) color!: string
	@Prop({ required: true, type: String }) id!: string
	@Prop({ required: true, type: Number }) infoId!: number

	form = {
		aliquot: 18,
		regime: 9.25,
		months: 60,
		monthlyIncome: '',
	}

	advanced = {
		selic: 1.25,
	}

	options = {
		regime: [
			{ text: 'Não cumulativo', value: 9.25 },
			{ text: 'Cumulativo', value: 3.65 },
		],
	}

	money = {
		decimal: ',',
		thousands: '.',
		precision: 2,
		masked: false,
	}

	get monthlySavings() {
		const monthlyIncomeInt = parseFloat(
			this.form.monthlyIncome.replaceAll('.', '').replaceAll(',', '.'),
		)
		const aliquotInt = this.form.aliquot / 100
		const regime = this.form.regime / 100

		const result = this.parse(monthlyIncomeInt * aliquotInt * regime)
		this.$emit('savings', result)

		return currencyFormat(result)
	}

	get recuperateOn() {
		const monthlySavings = parseFloat(
			this.monthlySavings.replaceAll('.', '').replaceAll(',', '.'),
		)
		const result = this.parse(
			monthlySavings * this.form.months * this.advanced.selic,
		)
		this.$emit('recuperate', result)
		return currencyFormat(result)
	}

	get selectedRegime() {
		const option = this.options.regime.find((option) => {
			return this.form.regime === option.value
		})

		return option ? option.text : ''
	}

	get calcsEach() {
		return this.$store.state.calculators.calcsEach
	}

	get calcsPrint() {
		return this.$store.state.calculators.calcsPrint
	}

	parse(n) {
		if (isNaN(n)) return 0
		n = parseFloat(n)
		return parseFloat(n.toFixed(2))
	}

	save() {
		this.savePrint()
		const found = this.calcsEach.find((item) => this.id === item.id)

		if (found) {
			found.aliquot = this.form.aliquot
			found.regime = this.form.regime
			found.months = this.form.months
			found.monthlyIncome = this.form.monthlyIncome
			found.selic = this.advanced.selic
		} else {
			this.calcsEach.unshift({
				id: this.id,
				aliquot: this.form.aliquot,
				regime: this.form.regime,
				months: this.form.months,
				monthlyIncome: this.form.monthlyIncome,
				selic: this.advanced.selic,
			})
		}
	}

	savePrint() {
		const found = this.calcsPrint.find((item) => this.id === item.id)

		const rows = () => {
			return [
				[
					{
						label: 'Faturamento Mensal',
						value: 'R$ ' + this.form.monthlyIncome,
					},
					{
						label: 'Alíquota de ICMS',
						value: this.form.aliquot + ' %',
					},
					{
						label: 'Regime',
						value: this.selectedRegime,
					},
				],
				[
					{
						label: 'Economia Mensal',
						value: 'R$ ' + this.monthlySavings,
					},
					{
						label: 'Recuperação em ' + this.form.months + ' meses',
						value: 'R$ ' + this.recuperateOn,
					},
				],
			]
		}

		if (found) {
			found.rows = rows()
			found.recuperate = this.recuperateOn
			found.savings = this.monthlySavings
		} else {
			this.calcsPrint.unshift({
				id: this.id,
				title: 'Exclusão do PIS e Cofins da Base do ICMS',
				color: this.color,
				columns: 3,
				rows: rows(),
				type: 'table',
				recuperate: this.recuperateOn,
				savings: this.monthlySavings,
			})
		}
	}

	created() {
		const found = this.calcsEach.find((item) => this.id === item.id)

		if (found) {
			this.form.aliquot = found.aliquot
			this.form.regime = found.regime
			this.form.months = found.months
			this.form.monthlyIncome = found.monthlyIncome
			this.advanced.selic = found.selic
		}
	}
}
